// extracted by mini-css-extract-plugin
export default {"container":"Error_container__bAn7Y","code":"Error_code__A1TdF","seperator":"Error_seperator__Vluk1","message":"Error_message__E+oyh"};